import { isEmpty } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ERROR_ICON_PATH } from 'constants/images.constants';
import { useSqPendingMethod } from 'context';
import { TranslationNamespace } from 'i18n';
import { TradeMethod, PaymentRulesViewProps } from 'types';
import { SqPaymentOption } from 'views/SqOrderView/components/SqPaymentOption';

export const SqPaymentRulesView: React.FC<PaymentRulesViewProps> = ({
  tradeMethods = [],
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.bank_select',
  });
  const { pendingTradeMethod, setPendingTradeMethod } = useSqPendingMethod();

  if (isEmpty(tradeMethods)) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-bg-payment-layout-out tw-py-4 tw-px-8 tw-rounded-xl">
        <img className="tw-w-8 tw-mr-4" src={ERROR_ICON_PATH} alt="error" />
        <div className="tw-text-secondary tw-text-lg">
          {t('errors.no_methods_available')}
        </div>
      </div>
    );
  }

  return (
    <div className="tw-w-full tw-flex tw-flex-col">
      {tradeMethods.map((tradeMethod: TradeMethod) => {
        const {
          paymentType,
          bank,
          bankName,
          paymentTypeName,
          fiatCurrency,
          comment,
        } = tradeMethod;

        return (
          <SqPaymentOption
            bank={bank}
            bankName={bankName}
            paymentType={paymentType}
            paymentTypeName={paymentTypeName}
            comment={comment}
            isSelected={
              pendingTradeMethod?.paymentType === paymentType &&
              pendingTradeMethod?.bank === bank
            }
            onSelect={() =>
              setPendingTradeMethod(
                pendingTradeMethod?.paymentType === paymentType &&
                  pendingTradeMethod?.bank === bank
                  ? undefined
                  : tradeMethod,
              )
            }
            key={paymentType + bank + fiatCurrency}
          />
        );
      })}
    </div>
  );
};
